import { DateTime } from 'luxon';

const apiDateToDateTime = (date?: string, zone: string = 'utc'): DateTime<true> | undefined => {
  if (!date) {
    return undefined;
  }
  const dateTime = DateTime.fromISO(date, { zone });

  if (!dateTime.isValid) {
    return undefined;
  }

  return dateTime;
};

export default apiDateToDateTime;
